<div class="media profile-media">
  <div class="media-body">
    <span>{{ userFullName }}</span>
    <p class="mb-0 font-roboto">{{ userRoleName }}</p>
  </div>
  <i class="middle fa fa-angle-down down-align"></i>
</div>
<ul class="profile-dropdown onhover-show-div">
    <li>
        <button (click)="logout()" class="logout-btn" aria-label="Log out from the application">
            <app-feather-icons [icon]="'log-in'"></app-feather-icons>
            <span>Log out</span>
        </button>
    </li>
</ul>

<ng-template #sessionoutPopupModal let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Session Timeout</h4>
    <button
      type="button"
      class="close"
      aria-label="Close"
      (click)="modal.dismiss('Cross click')"
    >
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div>
    <div class="modal-body">
      <p>{{ idleState }}</p>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary" (click)="logout()">
        Logout
      </button>
      <button type="submit" class="btn btn-primary btnstay" (click)="stay()">
        Stay
      </button>
    </div>
  </div>
</ng-template>
